import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class HelpersService {
  uuidv4() {
    return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
      (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
    );
  }

  randomId(min = 1, max = 2000000) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  getCurrentISO() {
    return new Date().toISOString();
  }

  getCurrentDateTimeLocalFormat(): string {
    const now = new Date();

    const day = String(now.getDate()).padStart(2, '0');
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const year = now.getFullYear();

    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');

    return `${day}.${month}.${year}, ${hours}:${minutes}`;
  }

  format_ISO8601_DateTimeToLocalFormat(iso8601String: string) {
    const date = new Date(iso8601String);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Месяцы с 0
    const year = date.getFullYear();

    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    const res = `${day}.${month}.${year}, ${hours}:${minutes}`;
    // console.info(`From ${iso8601String} (${date}) convert to ${res}`)
    return res
  }

  saveFile(serverResponse: any, fileName: string) {
    const contentType = serverResponse.headers.get('Content-Type') || '';
    const blob = new Blob([serverResponse.body!], {type: contentType});
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = fileName;
    link.click();
    window.URL.revokeObjectURL(downloadUrl);
  }

  formatBytes(bytes: number) {
    const units = ['Б', 'КБ', 'МБ', 'ГБ'];
    const thresh = 1024;

    if (bytes < thresh) return `${bytes} Б`;

    const i = Math.floor(Math.log(bytes) / Math.log(thresh));
    const size = bytes / Math.pow(thresh, i);
    return `${size.toFixed(2).replace('.', ',')} ${units[i]}`;
  }
}
